/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdDomainSettingsUrlOpenMethod;
(function (FxIdDomainSettingsUrlOpenMethod) {
    FxIdDomainSettingsUrlOpenMethod[FxIdDomainSettingsUrlOpenMethod["Unspecified"] = 0] = "Unspecified";
    FxIdDomainSettingsUrlOpenMethod[FxIdDomainSettingsUrlOpenMethod["Modal"] = 1] = "Modal";
    FxIdDomainSettingsUrlOpenMethod[FxIdDomainSettingsUrlOpenMethod["NewPage"] = 2] = "NewPage";
    FxIdDomainSettingsUrlOpenMethod[FxIdDomainSettingsUrlOpenMethod["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainSettingsUrlOpenMethod || (FxIdDomainSettingsUrlOpenMethod = {}));
export function instanceOfFxIdDomainSettingsUrlOpenMethod(value) {
    for (const key in FxIdDomainSettingsUrlOpenMethod) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainSettingsUrlOpenMethod, key)) {
            if (FxIdDomainSettingsUrlOpenMethod[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainSettingsUrlOpenMethodFromJSON(json) {
    return FxIdDomainSettingsUrlOpenMethodFromJSONTyped(json, false);
}
export function FxIdDomainSettingsUrlOpenMethodFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainSettingsUrlOpenMethodToJSON(value) {
    return value;
}
export function FxIdDomainSettingsUrlOpenMethodToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainSettingsUrlOpenMethod.js.map